import React, { createContext, useContext, useState, useEffect } from "react";
import en from "./en";
import ar from "./ar";

type Language = "en" | "ar";
type Translations = typeof en;

interface LanguageContextType {
  lang: Language;
  t: Translations;
  toggleLanguage: () => void;
  dir: "ltr" | "rtl";
}

const LanguageContext = createContext<LanguageContextType>({
  lang: "ar",
  t: ar as unknown as Translations,
  toggleLanguage: () => {},
  dir: "rtl",
});

const translations: Record<Language, Translations> = { en, ar: ar as unknown as Translations };

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Default language is Arabic
  const [lang, setLang] = useState<Language>("ar");

  const toggleLanguage = () => {
    setLang((prev) => (prev === "en" ? "ar" : "en"));
  };

  const dir = lang === "ar" ? "rtl" : "ltr";

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = dir;
  }, [lang, dir]);

  return (
    <LanguageContext.Provider value={{ lang, t: translations[lang], toggleLanguage, dir }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
